/**
 * Age Confirmation Gate
 *
 * Manages a required age confirmation checkbox on the cart drawer and cart page.
 * When checked, sets a cart attribute (age_confirmed) via /cart/update.js.
 * When unchecked, clears it. Checkout buttons are disabled until confirmed.
 *
 * Loaded once from theme.liquid with defer. Uses event delegation on
 * document.body so handlers survive AJAX re-renders. A MutationObserver
 * re-syncs state after innerHTML replacements by CartDrawer.renderContents()
 * and CartItems.updateQuantity().
 */
(function () {
  const ATTR_KEY = 'age_confirmed';
  const CHECKBOX_SEL = '[data-age-confirmation-checkbox]';
  const CHECKOUT_BTN_SEL = '[data-age-gate-checkout]';
  const CONTAINER_SEL = '.age-confirmation';
  const DYNAMIC_CHECKOUT_SEL = '.cart__footer-dynamic-checkout';

  let inFlight = false;

  function isConfirmed() {
    const container = document.querySelector(CONTAINER_SEL);
    if (!container) return false;
    const val = container.getAttribute('data-age-confirmed');
    return val && val.length > 0;
  }

  function syncState() {
    if (inFlight) return;

    const confirmed = isConfirmed();

    // Sync all checkboxes
    document.querySelectorAll(CHECKBOX_SEL).forEach(function (cb) {
      cb.checked = confirmed;
    });

    // Toggle checkout buttons
    document.querySelectorAll(CHECKOUT_BTN_SEL).forEach(function (btn) {
      btn.disabled = !confirmed;
    });

    // Toggle dynamic checkout visibility
    document.querySelectorAll(DYNAMIC_CHECKOUT_SEL).forEach(function (el) {
      el.classList.toggle('age-gate--locked', !confirmed);
    });
  }

  function setAgeAttribute(confirmed) {
    inFlight = true;

    const value = confirmed
      ? 'Yes - 21+ confirmed at ' + new Date().toISOString()
      : '';

    // Optimistic UI update
    document.querySelectorAll(CHECKOUT_BTN_SEL).forEach(function (btn) {
      btn.disabled = !confirmed;
    });
    document.querySelectorAll(DYNAMIC_CHECKOUT_SEL).forEach(function (el) {
      el.classList.toggle('age-gate--locked', !confirmed);
    });

    const attrs = {};
    attrs[ATTR_KEY] = value;
    const body = JSON.stringify({ attributes: attrs });

    fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body
    })
      .then(function () {
        // Update data attribute on containers so future syncState reads are correct
        document.querySelectorAll(CONTAINER_SEL).forEach(function (el) {
          el.setAttribute('data-age-confirmed', value);
        });
      })
      .catch(function (err) {
        console.error('Age confirmation update failed:', err);
        // Revert on error
        document.querySelectorAll(CHECKBOX_SEL).forEach(function (cb) {
          cb.checked = !confirmed;
        });
        document.querySelectorAll(CHECKOUT_BTN_SEL).forEach(function (btn) {
          btn.disabled = confirmed;
        });
        document.querySelectorAll(DYNAMIC_CHECKOUT_SEL).forEach(function (el) {
          el.classList.toggle('age-gate--locked', confirmed);
        });
      })
      .finally(function () {
        inFlight = false;
      });
  }

  // Event delegation — survives DOM replacement
  document.body.addEventListener('change', function (e) {
    if (e.target.matches(CHECKBOX_SEL)) {
      setAgeAttribute(e.target.checked);
      // Sync all other checkboxes (drawer + page may both exist)
      document.querySelectorAll(CHECKBOX_SEL).forEach(function (cb) {
        if (cb !== e.target) cb.checked = e.target.checked;
      });
    }
  });

  // MutationObserver — re-sync after AJAX innerHTML replacements
  function observeContainer(id) {
    var target = document.getElementById(id);
    if (!target) return;
    var observer = new MutationObserver(function () {
      // Debounce — innerHTML swap triggers multiple mutations
      clearTimeout(observer._t);
      observer._t = setTimeout(syncState, 50);
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  // Init
  function init() {
    syncState();
    observeContainer('CartDrawer');
    observeContainer('main-cart-footer');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
